import useDebounce from '@react-hook/debounce'
import {isString} from 'lodash'
import React, {useEffect, useState} from 'react'

import {SEARCH_DELAY_IN_MS} from '../../consts'
import type {User} from '../../types'

import {Autocomplete, type AutocompleteProps} from './Autocomplete'

type UserSearchProps = Omit<AutocompleteProps<User>, 'options' | 'onInputChange'> & {
  query: {data?: User[]; isFetching: boolean}
  onInputChange: (searchTerm: string) => void
  'data-test-id'?: string
}

const getOptionLabel = (option: User | string) => (isString(option) ? option : option?.name)

export const UserSearchAutocomplete: React.FC<UserSearchProps> = ({
  query,
  value,
  onInputChange,
  ...rest
}) => {
  const [open, setOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useDebounce('', SEARCH_DELAY_IN_MS)

  const {data = [], isFetching} = query

  useEffect(() => {
    onInputChange(searchTerm.length >= 3 ? searchTerm : '')
  }, [onInputChange, searchTerm])

  return (
    <Autocomplete
      {...rest}
      value={value}
      onInputChange={(_, newValue) => setSearchTerm(newValue)}
      open={open && data.length >= 0}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={data}
      filterSelectedOptions
      getOptionLabel={getOptionLabel}
      loading={isFetching}
    />
  )
}
